"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicatorsType = void 0;
const react_1 = __importStar(require("react"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const mod_1 = __importDefault(require("../../utils/number/mod"));
const timeInterval_1 = __importDefault(require("../../utils/timer/timeInterval"));
const Next_1 = __importDefault(require("./Next"));
const Prev_1 = __importDefault(require("./Prev"));
require("./Carousel.css");
var IndicatorsType;
(function (IndicatorsType) {
    IndicatorsType["Bullet"] = "bullet";
    IndicatorsType["Dash"] = "dash";
})(IndicatorsType = exports.IndicatorsType || (exports.IndicatorsType = {}));
exports.default = react_1.default.memo(function Carousel(_a) {
    var { className, children, progress, onMove, time, autoResize, indicatorsType } = _a, props = __rest(_a, ["className", "children", "progress", "onMove", "time", "autoResize", "indicatorsType"]);
    const size = react_1.default.Children.count(children);
    const childrenRefs = (0, react_1.useRef)(new Array(size));
    const [state, setState] = (0, react_1.useState)({
        current: 0,
        carouselScrollHeight: undefined,
        touchStart: 0,
        touchEnd: 0,
        timer: null,
    });
    (0, react_1.useEffect)(() => {
        if (state.current > size) {
            handleMove(0);
        }
    }, [size, state.current]);
    (0, react_1.useEffect)(() => {
        if (Number(time !== null && time !== void 0 ? time : 5000) > 0) {
            setState((prev) => {
                const newTimer = new timeInterval_1.default(() => {
                    handleMove(1);
                }, Number(time !== null && time !== void 0 ? time : 5000)).start();
                return Object.assign(Object.assign({}, prev), { timer: newTimer });
            });
        }
        return () => {
            setState((prev) => {
                var _a;
                (_a = prev.timer) === null || _a === void 0 ? void 0 : _a.stop();
                return Object.assign(Object.assign({}, prev), { timer: null });
            });
        };
    }, [time]);
    const handleTimerOn = (0, react_1.useCallback)(() => {
        var _a;
        (_a = state.timer) === null || _a === void 0 ? void 0 : _a.start();
    }, [state.timer]);
    const handleTimerOff = (0, react_1.useCallback)(() => {
        var _a;
        (_a = state.timer) === null || _a === void 0 ? void 0 : _a.stop();
    }, [state.timer]);
    const handleMove = (0, react_1.useCallback)((diff) => {
        if (autoResize) {
            let height = 0;
            setState((prev) => {
                const next = (0, mod_1.default)(prev.current + diff, childrenRefs.current.length);
                height = childrenRefs.current[next];
                return Object.assign(Object.assign({}, prev), { current: next, carouselScrollHeight: height + 'px' });
            });
        }
        else {
            let height = 0;
            childrenRefs.current.map((element) => {
                height = Math.max(element, height);
            });
            setState((prev) => (Object.assign(Object.assign({}, prev), { current: (0, mod_1.default)(prev.current + diff, childrenRefs.current.length), carouselScrollHeight: height + 'px' })));
        }
        if (onMove) {
            onMove((0, mod_1.default)(state.current + diff, childrenRefs.current.length));
        }
    }, [state, onMove]);
    const handleTouchStart = (0, react_1.useCallback)((e) => {
        setState((prev) => {
            var _a;
            (_a = prev.timer) === null || _a === void 0 ? void 0 : _a.stop();
            return Object.assign(Object.assign({}, prev), { touchStart: e.targetTouches[0].clientX, touchEnd: e.targetTouches[0].clientX });
        });
    }, []);
    const handleTouchMove = (0, react_1.useCallback)((e) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { touchEnd: e.targetTouches[0].clientX })));
    }, []);
    const handleTouchEnd = (0, react_1.useCallback)((e) => {
        handleTimerOn();
        if (state.touchStart - state.touchEnd > 150) {
            handleMove(1);
        }
        if (state.touchStart - state.touchEnd < -150) {
            handleMove(-1);
        }
    }, [state]);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: TokenList_1.default.join([
            'Carousel',
            className,
            indicatorsType === IndicatorsType.Dash && 'dash-indicators',
        ]) }),
        react_1.default.createElement("div", { className: "Carousel__Items" },
            react_1.default.createElement("div", { className: "Carousel__Scroll", onMouseEnter: handleTimerOff, onMouseLeave: handleTimerOn, style: { height: state.carouselScrollHeight }, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd }, react_1.default.Children.map(children, (child, i) => (react_1.default.createElement("div", { key: 'item:' + i, ref: (el) => {
                    childrenRefs.current[i] = el === null || el === void 0 ? void 0 : el.scrollHeight;
                }, className: TokenList_1.default.join([
                    'Carousel__Item',
                    i === 0 && 'Carousel__Item--first',
                    i < state.current && 'Carousel__Item--on-left',
                    i === state.current && 'Carousel__Item--active',
                    i > state.current && 'Carousel__Item--on-right',
                ]) }, child))))),
        size > 1 && (react_1.default.createElement("div", { className: "Carousel__List" }, react_1.default.Children.map(children, (_, i) => (react_1.default.createElement("div", { key: 'list:' + i, onClick: () => handleMove(i), className: TokenList_1.default.join([
                progress && i <= state.current && 'active',
                !progress && i === state.current && 'active',
            ]) },
            react_1.default.createElement("div", null)))))),
        size > 1 && (react_1.default.createElement("div", { onClick: () => {
                handleMove(1);
            }, className: TokenList_1.default.join([
                'Carousel__Next',
                progress && state.current === size - 1 && 'disabled',
            ]) },
            react_1.default.createElement(Next_1.default, null))),
        size > 1 && (react_1.default.createElement("div", { onClick: () => {
                handleMove(-1);
            }, className: TokenList_1.default.join([
                'Carousel__Prev',
                progress && state.current === 0 && 'disabled',
            ]) },
            react_1.default.createElement(Prev_1.default, null)))));
});
